// extracted by mini-css-extract-plugin
export default {"clipImageContainer":"small-picture_clipImageContainer__NF9yK","clipImage":"small-picture_clipImage__GT2WX","expandIcon":"small-picture_expandIcon__UHkdk"};